"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
// @ts-ignore
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const Tooltip_1 = __importDefault(require("./Tooltip"));
const colors_1 = require("./colors");
const CopyText = (props) => {
    const { value, successMessage, onClick, hoverText, duration, style, className } = props;
    const [copied, setCopied] = react_1.useState(false);
    const [isHovered, setIsHovered] = react_1.useState(false);
    const clickHandler = (e) => {
        var _a;
        copy_to_clipboard_1.default(value || ((_a = props.children) === null || _a === void 0 ? void 0 : _a.toString()) || '');
        setCopied(true);
        setTimeout(() => setCopied(false), duration || 1500);
        if (onClick) {
            onClick(e);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Tooltip_1.default, { direction: 'top', contents: copied ? successMessage
                : (isHovered ? hoverText || 'Click To Copy' : ''), show: isHovered || copied },
            react_1.default.createElement("button", { className: className, onClick: clickHandler, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), style: Object.assign({ backgroundColor: colors_1.sky.base, color: colors_1.ocean.base, border: 'none', padding: 0 }, style), tabIndex: 0, "aria-label": (props.children || value) + '. ' + (hoverText || 'Click to Copy') },
                props.children || value,
                " ",
                react_1.default.createElement("i", { className: 'fa fa-copy', "aria-hidden": true })))));
};
CopyText.propTypes = {
    value: prop_types_1.default.string,
    successMessage: prop_types_1.default.string,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    hoverText: prop_types_1.default.string,
    duration: prop_types_1.default.number,
    style: react_style_proptype_1.default,
};
CopyText.defaultProps = {
    successMessage: 'Copied successfully.',
};
exports.default = CopyText;
